import { HYBRID_SORTABLE_NOTICE_SEMANTIC_FIELDS } from "components/notices_v2/noticeSemanticSort";
import { ColumnSetting } from "lib/types/models";
import { NoticeSemanticColumnField } from "lib/types/savedViews";

const NOTICE_SEMANTIC_COLUMN_TITLES: Record<NoticeSemanticColumnField, string> = {
  relevanceScore: "Score",
  title: "Title & buyer",
  stage: "Stage",
  value: "Value",
  suppliers: "Supplier(s)",
  actions: "Actions",
  awardDate: "Award date",
  closeDate: "Close date",
  expiryDate: "Expiry date",
  publishDate: "Publish date",
};

const DEFAULT_COLUMN_SETTINGS: { field: NoticeSemanticColumnField }[] = [
  { field: "title" },
  { field: "stage" },
  { field: "value" },
  { field: "actions" },
  { field: "publishDate" },
];

export const DEFAULT_NOTICE_SEMANTIC_COLUMN_FIELDS: NoticeSemanticColumnField[] =
  DEFAULT_COLUMN_SETTINGS.map((c) => c.field);

/** Hybrid-sortable columns not included in the default visible set (column picker extras). */
export const OPTIONAL_HYBRID_NOTICE_SEMANTIC_COLUMN_FIELDS =
  HYBRID_SORTABLE_NOTICE_SEMANTIC_FIELDS.filter(
    (field) => !DEFAULT_NOTICE_SEMANTIC_COLUMN_FIELDS.includes(field),
  );

function columnSetting(
  field: NoticeSemanticColumnField,
  options?: { disabled?: boolean },
): ColumnSetting<NoticeSemanticColumnField> {
  return {
    field,
    title: NOTICE_SEMANTIC_COLUMN_TITLES[field],
    ...options,
  };
}

/** Columns available in the Notices V2 column picker (excludes relevanceScore). */
export const PICKER_NOTICE_SEMANTIC_COLUMNS: ColumnSetting<NoticeSemanticColumnField>[] = [
  ...DEFAULT_NOTICE_SEMANTIC_COLUMN_FIELDS.map((field) =>
    columnSetting(field, field === "title" ? { disabled: true } : undefined),
  ),
  ...OPTIONAL_HYBRID_NOTICE_SEMANTIC_COLUMN_FIELDS.map((field) => columnSetting(field)),
];

/** Removes sort-only relevanceScore from stored/URL column lists; ensures at least one column. */
export function normalizeNoticeSemanticColumnFields(
  columns: NoticeSemanticColumnField[],
): NoticeSemanticColumnField[] {
  const filtered = columns.filter((field) => field !== "relevanceScore");
  if (filtered.length === 0) {
    return [...DEFAULT_NOTICE_SEMANTIC_COLUMN_FIELDS];
  }
  return filtered;
}
